module.exports = __webpack_public_path__ + "static/media/Einfach-Bequem2.dbcf4d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Einfach-Bequem2.jpg
// module id = 234
// module chunks = 8